var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurantIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2884_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2969 3.24805C11.5335 4.2052 12.3981 4.91704 13.4261 4.91704C14.4424 4.91704 15.3158 4.20594 15.5778 3.24805H11.2969Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 10.167H8.51562V11.5736H10.9432V10.167Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45878 10.167H5.03125V11.5736H7.45878V10.167Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4275 10.167H12V11.5736H14.4275V10.167Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4254 5.97218C12.2877 5.97218 11.2848 5.38384 10.7043 4.49512C10.1239 5.3838 9.12092 5.97218 7.9832 5.97218C6.84548 5.97218 5.84254 5.38384 5.26207 4.49512C4.68164 5.3838 3.67867 5.97218 2.54098 5.97218C2.19437 5.97218 1.86033 5.91736 1.54688 5.81626V9.1118H14.4219V5.81584C14.1034 5.91824 13.7683 5.97218 13.4254 5.97218Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 12.6279H1.54688V15.9996H14.4219V12.6279Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97444 10.167H1.54688V11.5736H3.97444V10.167Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5494 0H1.46732L0.601562 2.19337H15.4152L14.5494 0Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98864 4.91704C9.01665 4.91704 9.88135 4.2052 10.1179 3.24805H5.85938C6.09593 4.2052 6.96063 4.91704 7.98864 4.91704Z",
    fill: "#344767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67288 3.24805H0.414062C0.650581 4.20527 1.5156 4.91704 2.54364 4.91704C3.57162 4.91704 4.43632 4.2052 4.67288 3.24805Z",
    fill: "#344767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2884_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantIconBlue);
export default __webpack_public_path__ + "static/media/restaurantIconBlue.104a4e7da76929d9eecc34cc33f0a91a.svg";
export { ForwardRef as ReactComponent };